export class ProximityConstraintAllocationRequestType {
	constructor() {
	}
} 

